import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import isEqual from "react-fast-compare";
import Image from "antd/lib/image";
import Popover from "antd/lib/popover";
import Tooltip from "antd/lib/tooltip";
import Modal from "antd/lib/modal";
import CarouselWidgetMaker from "./Carousel";
import CustomCardFooter from "../../components/WidgetMaker/CustomCard/CustomCardFooter";
import CustomCardHeader from "../../components/WidgetMaker/CustomCard/CustomCardHeader";
import CustomCardContent from "../../components/WidgetMaker/CustomCard/CustomCardContent";
import Profile from "../../assets/Profile_Pic.svg";
import fx from "../../assets/WidgetMaker/FX.svg";
import InfoIcon from "../../assets/Info_Icon.svg";
import InfoIconYellow from "../../assets/Info_Icon_Yellow.svg";
import BoostedPostIcon from "../../assets/boosted_post_icon.svg";
import AdsPostIcon from "../../assets/ads_post_icon.svg";
import defaultImg from "../../assets/WidgetMaker/Brocken_Image.svg";
import placeHolderImg from "../../assets/placeholder_img.png";
import Default_Brand from "../../assets/brandLogos/Default_Brand.svg";
import userFollowers from "../../assets/FollowersBlue.svg";
import ClockIcon from "../../assets/Clock.svg";
import verified from "../../assets/verified.svg";
import somethingWentWrong from "../../assets/No_Data_Found.svg";
import androidImage from "../../assets/android_icon_image.svg";
import {
  getClass,
  getTextDirection,
  getTextWithWrapHtml,
  getunMaskedText,
  kFormatter,
} from "../../redux/constants";
import { SocialMedialogo } from "../layout/DeepDive/DeepDivetab/SocialMediaPlatforms";
import PostCardFooter from "./PostCardFooter";
import moment from "moment";
import { Rate } from "antd";
import VideoPreview from "./VideoPreview";
import saved from "../../assets/deepDive/Saved.svg";
import white_Saved from "../../assets/deepDive/white_Saved.svg";
import tiredEmoji from "../../assets/icons/Tired.png";
import frowningFace from "../../assets/icons/Frowning-Face.png";
import neutralFace from "../../assets/icons/Neutral-Face.png";
import smilingFaceWithSmilingEyes from "../../assets/icons/Smiling-Face-With-Smiling-Eyes.png";
import smilingFaceWithHeartEyes from "../../assets/icons/Smiling-Face-With-Heart-Eyes.png";
import GallaryCard from "../commandCenter/shared/components/GallaryCard/GallaryCard";
import { setPauseAnimationWhenPopupOpen } from "../../redux/actions/commandCenter/screens/screen";
import {
  ElementTypeEnum,
  NPS_OPTIONS,
  postCardUserBrandCommentId,
  postCardUserbrandPrivateMessagesId,
  sentimentClass,
} from "../../redux/constants/enums";
import PostLabels from "./PostLabels";
import pdfIcon from "../../assets/pdf-svg-icon.svg";
import { getDynamicIconColor } from "../../redux/constants/DynamicIconColor";
import parse from "html-react-parser";
import { MentionIdComponent } from "./MentionIdComponent";
import EngagedCard from "./EngagedCard";

const PostCardDetails = ({
  data,
  modalData,
  PdfDownloadStatus,
  PptGeneratingStatus,
  isPreviewState,
  setIsModalOpen,
  isModalOpen,
  setIsModalData,
  isModalLoader,
  setIsModalLoader,
  isCommandCenterScreen,
  custom_card_settings,
  metadata,
  deepDive,
  isReviewCard = false,
  el,
  setAutoPlay,
  trendView,
  dontShowCustomCard = false,
  qrChannel,
  pantipChannel,
  section_index,
  widget_index,
  highlightWord,
  isDeepDiveDashboardView = false,
  type,
}) => {
  const dispatch = useDispatch();
  const authParams = useSelector((state) => state.Authentication.authParams);
  const dashboardTrendsFlag = useSelector(
    (state) => state.WidgetAPI.dashboardTrendsFlag
  );
  const isDashboardScheduleModal = useSelector(
    (state) => state?.ApiCall?.is_dashboard_schedule_modal
  );
  const workspace_privileges = useSelector(
    (state) => state.ApiCall.workspace_privileges
  );
  const share_workspace_privileges = useSelector(
    (state) => state.ApiCall.share_workspace_privileges
  );
  const [visible, setVisible] = useState(false);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [videoPreview, setVideoPreview] = useState();
  const [isValidUrlFlag, setIsValidUrlFlag] = useState(null);
  const unMaskedInfo = useSelector((state) => state.ApiCall.unMaskedInfo);
  const unMaskedInfoId = useSelector((state) => state.ApiCall.unMaskedInfoId);
  const [finalPostText, setFinalPostText] = useState("");
  const [isModalReadMore, setIsModalReadMore] = useState({
    value: false,
    id: null,
  });
  const [isImage, setIsImage] = useState(false);

  const [highlightInfoMetrics, setHighlightInfoMetrics] = useState(null);

  const handleCancel = () => {
    // To Start Carousel in Brand Post Screen
    if (
      authParams?.screen_id === "000-000-562" &&
      !trendView &&
      !isDeepDiveDashboardView
    ) {
      setAutoPlay(true);
    }
    dispatch(setPauseAnimationWhenPopupOpen(false));
    setIsImage(false);
    setIsModalOpen(false);
    setIsModalData(null);
    setIsModalReadMore({ value: false, id: null });
  };
  const getDefautBrandImg = (e) => {
    return (e.target.src = Default_Brand);
  };
  const onImageError = (e) => {
    if (e?.type === "error") {
      setIsImage(true);
    } else {
      setIsImage(false);
    }
    return (e.target.src = defaultImg);
  };
  useEffect(() => {
    let handler = setTimeout(() => {
      setIsModalLoader(false);
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, [isModalLoader]);

  useEffect(() => {
    if (unMaskedInfo !== null) {
      setTimeout(() => {
        for (let i = 0; i < unMaskedInfoId?.length; i++) {
          if (
            unMaskedInfoId?.[i]?.TagID === el?.TagID ||
            unMaskedInfoId?.[i]?.TagID === el?.tagid
          ) {
            setFinalPostText(unMaskedInfoId?.[i]?.unmaskedPostText);
            break;
          }
        }
      }, 300);
    }
  }, [unMaskedInfo, unMaskedInfoId]);

  const isScontentLinkExpire = (mediaUrl, channelType) => {
    let isExpired = false;
    try {
      if (
        mediaUrl &&
        mediaUrl.indexOf("s3.amazonaws") == -1 &&
        mediaUrl.indexOf("images.locobuzz.com") == -1
      ) {
        const tokens = mediaUrl.split("&");
        const HexDecimalCode = tokens.filter((x) => x.includes("oe="));
        if (
          HexDecimalCode != null &&
          HexDecimalCode.length > 0 &&
          HexDecimalCode[0].startsWith("oe=")
        ) {
          let DecimalEpoch = 0;
          if (HexDecimalCode.length > 0) {
            const HexDecimalTime = HexDecimalCode[0].replace("oe=", "");
            DecimalEpoch = parseInt(HexDecimalTime, 16);
          }
          // DateTimeOffset.Now.ToUnixTimeSeconds()
          if (moment().unix() > DecimalEpoch && DecimalEpoch > 0) {
            isExpired = true;
          }
        }
      }
    } catch (exception) {
      return false;
    }

    return isExpired;
  };
  const idPresentFlag =
    unMaskedInfo?.tagids?.includes(el?.TagID) ||
    unMaskedInfo?.tagids?.includes(el?.tagid);

  const handleVideoPreview = (imgUrl) => {
    setIsVideoModalOpen(true);
    setVideoPreview(imgUrl?.MediaUrl);

    let isValidUrlFlag = isScontentLinkExpire(imgUrl?.MediaUrl, 1);
    setIsValidUrlFlag(isValidUrlFlag);
  };
  const screenId = authParams?.screen_id;

  qrChannel = useMemo(() => {
    return (
      modalData &&
      modalData?.SurveySubmitJson &&
      Array?.isArray(modalData?.SurveySubmitJson) &&
      modalData?.SurveySubmitJson?.length > 0
    );
  }, [modalData]);
  pantipChannel = useMemo(() => {
    return modalData && modalData?.PlatformID === 43;
  }, [modalData]);

  let needToShowScrollableContent =
    (workspace_privileges?.environment === 2 ||
      share_workspace_privileges?.environment === 2) &&
    (modalData?.PlatformID === 43 || modalData?.PlatformID === 25);
  let textDirection = getTextDirection(
    finalPostText || modalData?.PostText || modalData?.mention_text
  );
  let textDirectionClass = textDirection === "rtl" ? "text-right-arabic" : "";
  return (
    <Modal
      title={
        <div className="text_heading-Slab font-size16 font-weight500 modal_title_theme">
          {type === "engagedCard" ? "Engaged User Profile" : "Card Details"}
        </div>
      }
      footer={null}
      visible={isModalOpen}
      onOk={handleCancel}
      onCancel={handleCancel}
      width={
        authParams?.screen_id === "000-000-561" &&
        !deepDive &&
        !dashboardTrendsFlag &&
        !isDeepDiveDashboardView
          ? "70%"
          : 675
      }
      style={{ top: type === "engagedCard" ? "6rem" : "2rem" }}
      className={`postCard_dtails ${
        (screenId === "000-000-551" ||
          screenId === "000-000-555" ||
          screenId === "000-000-556" ||
          screenId === "000-000-557") &&
        !isDeepDiveDashboardView
          ? "CommandCenter__mentionCard--details"
          : ""
      } ${authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"}`}
    >
      {modalData ? (
        isModalLoader ? (
          <div className="loader" style={{ height: "45rem" }}>
            <div className="lds-ring">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        ) : type === "engagedCard" ? (
          <EngagedCard data={modalData} detailedView={true} />
        ) : authParams?.screen_id === "000-000-561" &&
          !deepDive &&
          !dashboardTrendsFlag &&
          !isDeepDiveDashboardView ? (
          <GallaryCard
            cardData={modalData}
            isCurrentSlide={true}
            center={true}
            isDetailView={true}
            metadata={metadata}
          />
        ) : authParams?.screen_id &&
          !dontShowCustomCard &&
          !deepDive &&
          !isDeepDiveDashboardView &&
          !dashboardTrendsFlag ? (
          <div
            className={`postcard-class-for-mention card cardList postCardItem text-left ${
              sentimentClass[modalData.SentimentType] || "default-text-color"
            }`}
          >
            <MentionIdComponent
              color={modalData?.SentimentType}
              id={modalData?.mention_id}
              postCardDetails={true}
            />
            <CustomCardHeader
              el={modalData}
              data={data}
              custom_card_settings={custom_card_settings}
              PdfDownloadStatus={PdfDownloadStatus}
              PptGeneratingStatus={PptGeneratingStatus}
              isCommandCenterScreen={isCommandCenterScreen}
              postDetail={true}
            />

            <div
              className={`card-body ${
                qrChannel ? "p-1" : "p-0"
              } custom_scroll1`}
              style={{ maxHeight: "calc(100vh - 27.2rem)", overflow: "auto" }}
            >
              {modalData?.PlatformID === 1 ||
              modalData?.PlatformID === 7 ||
              modalData?.PlatformID === 30 ? (
                <div
                  className={`${
                    PdfDownloadStatus ? "mb-5" : "mb-15"
                  }  pl-15 d-flex justify-content-between pr-15`}
                >
                  {/* {modalData?.PlatformID === 1 ? (
                    <span className="mr-15 d-flex align-items-center no--wrap">
                      <img
                        src={userFollowers}
                        className="cardList__footer-label mr-1"
                        alt="userFollowers"
                      />
                      <span className="text-grayLight ml-1">Followers</span>
                      <span className="cardList__footer-count ml-1 blue-text font-weight800">
                        {kFormatter(modalData?.Followers)}
                      </span>
                    </span>
                  ) : (
                    ""
                  )} */}

                  {(modalData?.PlatformID === 7 ||
                    modalData?.PlatformID === 30) &&
                  modalData?.IsBrandPost === "User" ? (
                    <>
                      {modalData?.Rating >= 0 ? (
                        <span className="mr-15 d-flex align-items-center">
                          <Rate
                            disabled
                            value={
                              modalData?.Rating
                                ? modalData?.Rating
                                : modalData?.rating
                            }
                            className="d-flex no--wrap w-100 ratingList mr-1 "
                          />
                          {modalData?.Rating}
                        </span>
                      ) : (
                        ""
                      )}

                      {modalData?.PlatformID === 7 ? (
                        <span className="mr-15 d-flex align-items-center">
                          <span
                            className="w-100 text-ellipsis mr-1"
                            style={{ color: "blue" }}
                          >
                            App Version:
                          </span>
                          {modalData?.App_version === "NA" ? (
                            <>
                              <i
                                className={`fa fa-minus cursor-pointer ml-1 fontSize-12 ${
                                  window.location.pathname
                                    .toLowerCase()
                                    ?.includes("/commandcenter/screens")
                                    ? "dynamic_icon_color"
                                    : "text-gray"
                                }`}
                              />
                              <Tooltip
                                title="Version information is not available for this review."
                                placement="top"
                                className="text-ellipsis d-inline-block wm-chart-card-title"
                              >
                                <i
                                  className={`fa fa-info-circle cursor-pointer ml-1 ${
                                    window.location.pathname
                                      .toLowerCase()
                                      ?.includes("/commandcenter/screens")
                                      ? "dynamic_icon_color"
                                      : "text-gray"
                                  }`}
                                  style={{ overflow: "visible" }}
                                />
                              </Tooltip>
                            </>
                          ) : (
                            modalData?.App_version
                          )}
                        </span>
                      ) : (
                        ""
                      )}
                      {modalData?.PlatformID === 7 ? (
                        <span className="mr-15 d-flex align-items-center">
                          <img
                            src={androidImage}
                            alt="Android Image"
                            className="profileImg ml-1 mr-1"
                            style={{ width: "1.5rem" }}
                          />
                          {modalData?.Android_version}
                        </span>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                ""
              )}

              {modalData?.PlatformID === 7 &&
              modalData?.IsBrandPost === "User" ? (
                <span className="ml-15 mb-5 d-flex align-items-center">
                  <span className="d-flex w-100">
                    <span
                      className="text-ellipsis mr-1"
                      style={{ color: "blue" }}
                    >
                      Device Name:
                    </span>
                    <span className="text-ellipsis">{modalData?.Device}</span>
                  </span>
                </span>
              ) : (
                ""
              )}

              <div
                className={`cardList__body-description fontSize-12 pl-15 pr-15`}
              >
                {(modalData?.PostText || modalData?.mention_text) && (
                  <div
                    className={`text_regular break-word mb-15 ${textDirectionClass}`}
                  >
                    {!(
                      isModalReadMore?.value &&
                      isModalReadMore?.id === modalData?.TagID
                    ) && (
                      <>
                        <a
                          className={
                            modalData?.PostURL &&
                            modalData?.PostURL?.trim() &&
                            modalData?.PostURL !== "NA"
                              ? `${
                                  authParams?.screen_id ? "postCardTextCC" : ""
                                }`
                              : `pointer-events1 cursor-default ${
                                  authParams?.screen_id ? "postCardTextCC" : ""
                                }`
                          }
                          // href={
                          //   modalData?.PostURL &&
                          //   modalData?.PostURL?.trim() &&
                          //   modalData?.PostURL !== "NA"
                          //     ? modalData?.PostURL
                          //     : ""
                          // }
                          // target="_blank"
                          // rel="noreferrer"
                        >
                          {el?.IsMaskedMention &&
                          idPresentFlag &&
                          !isPreviewState &&
                          !isDashboardScheduleModal &&
                          !PdfDownloadStatus &&
                          !PptGeneratingStatus &&
                          (window.location.pathname?.split("/")?.[1] ===
                            "widgetMaker" ||
                            window.location.pathname?.split("/")?.[1] ===
                              "edit-widget" ||
                            window.location.pathname?.split("/")?.[1] ===
                              "dashboard" ||
                            window.location.pathname?.split("/")?.[1] ===
                              "pin-dashboard" ||
                            authParams?.screen_id)
                            ? finalPostText !== ""
                              ? getTextWithWrapHtml(
                                  finalPostText,
                                  "",
                                  highlightWord,
                                  textDirection,
                                  needToShowScrollableContent
                                )
                              : getTextWithWrapHtml(
                                  modalData?.PostText ||
                                    modalData?.mention_text,
                                  "",
                                  highlightWord,
                                  textDirection,
                                  needToShowScrollableContent
                                )
                            : getTextWithWrapHtml(
                                modalData?.PostText || modalData?.mention_text,
                                "",
                                highlightWord,
                                textDirection,
                                needToShowScrollableContent
                              )}
                        </a>
                      </>
                    )}
                  </div>
                )}

                {modalData?.Attachment?.length === 1 ? (
                  <div className="m-0 w-100 text-center position-relative postCard_dtails--image">
                    {modalData?.Attachment?.map((imgUrl, index) => {
                      if (
                        imgUrl?.MediaType === "2" ||
                        imgUrl?.MediaType === "4"
                      ) {
                        return imgUrl ? (
                          <>
                            <Image
                              src={
                                imgUrl?.ThumbUrl
                                  ? imgUrl?.ThumbUrl
                                  : imgUrl?.MediaUrl
                                  ? imgUrl?.MediaUrl
                                  : defaultImg
                              }
                              alt="Attachment Image"
                              style={{
                                borderRadius: "0.6rem",
                                objectFit: "cover",
                                minHeight: "35rem",
                              }}
                              onError={onImageError}
                              className="border w-100"
                              fallback={defaultImg}
                              preview={!isImage}
                              placeholder={
                                <Image
                                  src={placeHolderImg}
                                  preview={false}
                                  className="position_relative w-100"
                                  style={{
                                    borderRadius: "3.2rem",
                                    objectFit: "cover",
                                    height: "35rem",
                                  }}
                                />
                              }
                            />
                          </>
                        ) : (
                          ""
                        );
                      } else if (
                        imgUrl?.MediaType === "3" ||
                        imgUrl?.MediaType === "7"
                      ) {
                        return imgUrl && !PdfDownloadStatus ? (
                          <>
                            {modalData?.PlatformID === 2 ||
                            modalData?.PlatformID === 4 ||
                            modalData?.PlatformID === 37 ? (
                              <a
                                href={imgUrl?.MediaUrl ? imgUrl?.MediaUrl : ""}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <img
                                  src={
                                    imgUrl?.ThumbUrl
                                      ? imgUrl?.ThumbUrl
                                      : defaultImg
                                  }
                                  alt="Attachment Images"
                                  style={{ width: "100%", objectFit: "cover" }}
                                  onError={(modalData) =>
                                    onImageError(modalData)
                                  }
                                />
                                <div class="overlay-play-button__overlay">
                                  <div class="overlay-play-button__play">
                                    <i
                                      class="fa fa-play"
                                      style={{
                                        fontSize: "1.2rem",
                                        color: "#fff",
                                      }}
                                    ></i>
                                  </div>
                                </div>
                              </a>
                            ) : modalData?.PlatformID === 1 ||
                              modalData?.PlatformID === 3 ||
                              modalData?.PlatformID === 5 ||
                              modalData?.PlatformID === 42 ? (
                              <>
                                <div
                                  class="overlay-play-button"
                                  style={{ height: "25rem" }}
                                  onClick={() => handleVideoPreview(imgUrl)}
                                >
                                  <video
                                    width="100%"
                                    style={{
                                      objectFit: "cover",
                                      height: "25rem",
                                    }}
                                  >
                                    <source
                                      src={imgUrl?.MediaUrl}
                                      type="video/mp4"
                                    />
                                  </video>

                                  <div class="overlay-play-button__overlay">
                                    <div class="overlay-play-button__play">
                                      <i
                                        class="fa fa-play"
                                        style={{
                                          fontSize: "1.2rem",
                                          color: "#fff",
                                        }}
                                      ></i>
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : (
                              ""
                            )}

                            {/* For Video Preview */}
                            <VideoPreview
                              videoPreview={videoPreview}
                              setIsModalOpen={setIsVideoModalOpen}
                              isModalOpen={isVideoModalOpen}
                              isValidUrlFlag={isValidUrlFlag}
                            />
                          </>
                        ) : PdfDownloadStatus ? (
                          imgUrl && (
                            <img
                              src={imgUrl?.ThumbUrl}
                              alt="Attachment Images"
                              style={{
                                width: "8rem",
                                height: "6.6rem",
                              }}
                              onError={(modalData) => onImageError(modalData)}
                            />
                          )
                        ) : (
                          ""
                        );
                      } else if (imgUrl?.MediaType === "8") {
                        return (
                          <div
                            className="post__document"
                            style={{
                              width: "100%",
                              height: "30rem",
                            }}
                          >
                            <span className="post__document--files">
                              <a
                                href={imgUrl?.MediaUrl ? imgUrl?.MediaUrl : ""}
                                download={imgUrl?.Name}
                                target="_blank"
                                rel="noreferrer"
                                onClick={(e) => e?.stopPropagation()}
                              >
                                <img
                                  src={pdfIcon}
                                  alt="PDF Document"
                                  style={{
                                    width: "75%",
                                    height: "calc(100% - 5rem)",
                                    objectFit: "contain",
                                  }}
                                />
                                <Tooltip
                                  title={imgUrl?.Name}
                                  placement="bottom"
                                >
                                  <span className="post__document--name text__ellipsis-line2">
                                    {imgUrl?.Name}
                                  </span>
                                </Tooltip>
                              </a>
                            </span>
                          </div>
                        );
                      }
                    })}
                  </div>
                ) : (
                  modalData?.Attachment?.length > 1 && (
                    <div className="w-100">
                      <CarouselWidgetMaker
                        el={modalData}
                        height="40.3rem"
                        postCardDetails={true}
                        isViewFullImage={
                          modalData?.isModalOpen
                            ? modalData?.isModalOpen
                            : false
                        }
                        isDeepDiveDashboardView={isDeepDiveDashboardView}
                      />
                    </div>
                  )
                )}
              </div>
              {/* <PostCardFooter
                data={data}
                isPreviewState={isPreviewState}
                PdfDownloadStatus={PdfDownloadStatus}
                PptGeneratingStatus={PptGeneratingStatus}
                el={modalData}
                postDetail={true}
              /> */}
            </div>

            <CustomCardFooter
              el={modalData}
              data={data}
              custom_card_settings={custom_card_settings}
              PdfDownloadStatus={PdfDownloadStatus}
              PptGeneratingStatus={PptGeneratingStatus}
              isPreviewState={isPreviewState}
              isHideGlobal={
                modalData?.isModalOpen ? modalData?.isModalOpen : false
              }
              postDetail={
                authParams?.screen_id === "000-000-557" ||
                authParams?.screen_id === "000-000-562" ||
                authParams?.screen_id === "000-000-564"
                  ? true
                  : false
              }
            />
          </div>
        ) : (
          <div
            className={`postcard-class-for-mention card cardList postCardItem text-left ${
              sentimentClass[modalData.SentimentType]
            }`}
          >
            <MentionIdComponent
              color={modalData?.SentimentType}
              id={modalData?.mention_id}
              postCardDetails={true}
            />
            <div
              className={`cardList-head card-head text_heading d-flex justify-content-between p-15 mt-0 align-items-top ${
                modalData?.SentimentType && !qrChannel ? "pl-0" : ""
              } ${modalData?.IsDeletedFromSocial && !qrChannel ? "pr-0" : ""} ${
                postCardUserbrandPrivateMessagesId?.includes(
                  modalData?.channel_type
                )
                  ? getClass(authParams, "message")
                  : modalData?.PlatformID == 1 &&
                    modalData?.ParentSocialID !== "NA" &&
                    modalData?.ParentSocialID != 0 &&
                    modalData?.ParentSocialID !== ""
                  ? getClass(authParams, "comment")
                  : postCardUserBrandCommentId?.includes(
                      modalData?.channel_type
                    ) && modalData?.PlatformID != 1
                  ? getClass(authParams, "comment")
                  : getClass(authParams, "post")
              } ${modalData?.IsDeletedFromSocial && !qrChannel ? "pr-0" : ""} `}
            >
              <div
                className={`d-flex align-items-center`}
                style={{ width: "60%" }}
              >
                {modalData?.SentimentType ? (
                  <div
                    className={`${qrChannel ? "d-none" : ""}`}
                    style={{
                      borderLeft: `0.4rem solid ${
                        modalData?.SentimentType === "Positive"
                          ? "#5ED142"
                          : modalData?.SentimentType === "Negative"
                          ? "#FF5D48"
                          : modalData?.SentimentType === "Neutral"
                          ? "#F0C52F"
                          : "black"
                      }`,
                      height: "3.6rem",
                      marginRight: "1rem",
                    }}
                  ></div>
                ) : (
                  ""
                )}
                {isReviewCard ? (
                  ""
                ) : modalData?.brand_logo &&
                  modalData?.BrandFriendlyName &&
                  modalData?.BrandFriendlyName !== "NA" &&
                  modalData?.BrandFriendlyName !== "" ? (
                  <Popover
                    placement="leftBottom"
                    title={null}
                    content={
                      <div
                        style={{
                          maxWidth: "25rem",
                          maxHeight: "20rem",
                          overflow: "auto",
                        }}
                        className="text_regular fontSize-12 p-10"
                      >
                        {modalData?.BrandFriendlyName}
                      </div>
                    }
                    overlayClassName={
                      authParams?.theme_type === "1"
                        ? "darkTheme"
                        : "lightTheme"
                    }
                  >
                    <Image
                      src={
                        modalData?.brand_logo
                          ? modalData?.brand_logo
                          : Default_Brand
                      }
                      fallback={Default_Brand}
                      onError={getDefautBrandImg}
                      preview={false}
                      alt="Brand logo"
                      className={`profileImg mr-1 ${
                        qrChannel ? "d-none" : ""
                      } cursor-pointer`}
                      style={{
                        width: "3.5rem",
                        height: "3.5rem",
                        //marginTop: "-0.5rem",
                      }}
                      // crossOrigin="anonymous"
                    />
                  </Popover>
                ) : modalData?.BrandFriendlyName &&
                  modalData?.BrandFriendlyName !== "NA" &&
                  modalData?.BrandFriendlyName !== "" ? (
                  <Popover
                    placement="leftBottom"
                    title={null}
                    content={
                      <div
                        style={{
                          maxWidth: "25rem",
                          maxHeight: "20rem",
                          overflow: "auto",
                        }}
                        className="text_regular fontSize-12 p-10"
                      >
                        {modalData?.BrandFriendlyName}
                      </div>
                    }
                    overlayClassName={
                      authParams?.theme_type === "1"
                        ? "darkTheme"
                        : "lightTheme"
                    }
                  >
                    <Image
                      src={
                        modalData?.brand_logo
                          ? modalData?.brand_logo
                          : Default_Brand
                      }
                      fallback={Default_Brand}
                      onError={getDefautBrandImg}
                      preview={false}
                      alt="Brand logo"
                      className="profileImg mr-1 cursor-pointer"
                      style={{
                        width: "3.5rem",
                        height: "3.5rem",
                        //marginTop: "-0.5rem",
                      }}
                      // crossOrigin="anonymous"
                    />
                  </Popover>
                ) : (
                  <Image
                    src={
                      modalData?.brand_logo
                        ? modalData?.brand_logo
                        : Default_Brand
                    }
                    fallback={Default_Brand}
                    preview={false}
                    alt="Brand logo"
                    className="profileImg mr-1 cursor-pointer"
                    style={{
                      width: "3.5rem",
                      height: "3.5rem",
                      //marginTop: "-0.5rem",
                    }}
                    // crossOrigin="anonymous"
                  />
                )}

                {(authParams?.screen_id === "000-000-554" ||
                  authParams?.screen_id === "000-000-564") &&
                !isDeepDiveDashboardView ? (
                  ""
                ) : (
                  <div
                    className="position-relative mr-15"
                    style={{ width: "3.5rem" }}
                  >
                    {!PdfDownloadStatus && !PptGeneratingStatus ? (
                      <Popover
                        placement="leftBottom"
                        title={null}
                        content={
                          <div className="p-15">
                            {modalData?.AuthorBio &&
                            modalData?.AuthorBio !== "NA" &&
                            modalData?.AuthorBio !== "" ? (
                              <div className="text_regular font-weight500">
                                Bio
                              </div>
                            ) : (
                              ""
                            )}
                            <div
                              style={{
                                maxWidth: "35rem",
                                maxHeight: "20rem",
                                overflow: "auto",
                              }}
                              className="text_regular fontSize-12 custom_scroll1"
                            >
                              {modalData?.AuthorBio &&
                              modalData?.AuthorBio !== "NA" &&
                              modalData?.AuthorBio !== "" ? (
                                <>{modalData?.AuthorBio}</>
                              ) : (
                                <div className="text-grayLight fontSize-14 d-flex justify-content-center align-items-center w-100">
                                  Bio not found
                                </div>
                              )}
                            </div>
                          </div>
                        }
                        overlayClassName={
                          authParams?.theme_type === "1"
                            ? "darkTheme"
                            : "lightTheme"
                        }
                      >
                        <Image
                          src={
                            modalData?.picurl && modalData?.picurl !== ""
                              ? modalData?.picurl === 0 ||
                                modalData?.picurl === "" ||
                                !modalData?.picurl
                                ? Profile
                                : modalData?.picurl
                              : modalData?.ProfilePicture === 0 ||
                                modalData?.ProfilePicture === "" ||
                                !modalData?.ProfilePicture
                              ? Profile
                              : modalData?.ProfilePicture
                          }
                          fallback={Profile}
                          preview={false}
                          alt="Profile Images"
                          className="profileImg m-0 cursor-pointer"
                          style={{ width: "3.5rem", height: "3.5rem" }}
                          // crossOrigin="anonymous"
                        />
                      </Popover>
                    ) : (
                      <Image
                        src={
                          modalData?.picurl && modalData?.picurl !== ""
                            ? modalData?.picurl === 0 ||
                              modalData?.picurl === "" ||
                              !modalData?.picurl
                              ? Profile
                              : modalData?.picurl
                            : PdfDownloadStatus || PptGeneratingStatus
                            ? modalData?.ProfilePicture === 0 ||
                              modalData?.ProfilePicture === "" ||
                              !modalData?.ProfilePicture
                              ? Profile
                              : modalData?.ProfilePicture
                            : Profile
                        }
                        fallback={Profile}
                        preview={false}
                        alt="Profile Images"
                        className="profileImg m-0 cursor-pointer"
                        style={{ width: "3.5rem", height: "3.5rem" }}
                        // crossOrigin="anonymous"
                      />
                    )}
                    <div
                      className="position-absolute"
                      style={{ right: "-0.8rem", top: "-0.4rem" }}
                    >
                      <Image
                        src={
                          modalData?.PlatformID === 0
                            ? Default_Brand
                            : SocialMedialogo?.[modalData?.PlatformID]
                            ? SocialMedialogo?.[modalData?.PlatformID]
                            : Default_Brand
                        }
                        alt="Channel"
                        preview={false}
                        fallback={Default_Brand}
                        style={{
                          width: "1.6rem",
                          maxHeight: "2rem",
                          verticalAlign: "top",
                        }}
                      />
                    </div>
                  </div>
                )}
                {/* Changing max width logic here if sentimentType exits subtracting 1.5rem ,
                            85px + 0.4rem for Brand and Profile so Author Name box should not go outside  */}
                <div
                  // style={{ width: "calc(100% - 6rem)" }}
                  style={{
                    width: `calc(100% - ${
                      (modalData?.SentimentType ? 15 : 0) +
                      (!isReviewCard ? 35 : 0) + // for brand
                      (["000-000-554", "000-000-564"]?.includes(
                        authParams?.screen_id
                      ) && !isDeepDiveDashboardView
                        ? 0
                        : 50) // for profile
                    }px - ${!isReviewCard ? 0.4 : 0}rem)`,
                  }}
                >
                  <div className="d-flex align-items-center">
                    <Tooltip
                      title={
                        modalData?.Author
                          ? modalData?.Author
                          : modalData?.AuthorName
                      }
                    >
                      <div
                        className="profileName text-ellipsis line-height-normal"
                        style={{
                          maxWidth:
                            (modalData?.AuthorIsVerified !== "NA" &&
                              modalData?.AuthorIsVerified &&
                              modalData?.AuthorIsVerified > 0) ||
                            modalData?.isPromoted === true
                              ? "calc(100% - 2.5rem)"
                              : "",
                        }}
                      >
                        {modalData?.AuthorURL &&
                        modalData?.AuthorURL !== "NA" ? (
                          <a
                            className={
                              modalData?.AuthorURL &&
                              modalData?.AuthorURL !== "NA"
                                ? ""
                                : "pointer-events1 cursor-default"
                            }
                            href={
                              modalData?.AuthorURL &&
                              modalData?.AuthorURL !== "NA"
                                ? modalData?.AuthorURL
                                : ""
                            }
                            target="_blank"
                            rel="noreferrer"
                          >
                            {modalData?.Author
                              ? modalData?.Author
                              : modalData?.AuthorName}
                          </a>
                        ) : (
                          <>
                            {modalData?.Author
                              ? modalData?.Author
                              : modalData?.AuthorName}
                          </>
                        )}
                      </div>
                    </Tooltip>
                    {modalData?.AuthorIsVerified !== "NA" &&
                    modalData?.AuthorIsVerified &&
                    modalData?.AuthorIsVerified > 0 ? (
                      <img
                        src={verified}
                        alt="verified"
                        className="profileImg ml-1"
                        style={{ height: "1.6rem" }}
                      />
                    ) : (
                      ""
                    )}
                    {modalData?.isPromoted === 1 ? (
                      <Tooltip title="Boosted post">
                        <img
                          alt="Boosted Post Icon"
                          src={BoostedPostIcon}
                          className="mr-0"
                          style={{
                            width: "2rem",
                            height: "2rem",
                          }}
                        />
                      </Tooltip>
                    ) : modalData?.isPromoted === 2 ||
                      modalData?.isPromoted === 5 ? (
                      <Tooltip
                        title={
                          modalData?.isPromoted === 5
                            ? "Dark Ad Post"
                            : "Ad Post"
                        }
                      >
                        <img
                          alt="Ad Post Icon"
                          src={AdsPostIcon}
                          className="mr-0"
                          style={{
                            width: "2rem",
                            height: "2rem",
                          }}
                        />
                      </Tooltip>
                    ) : (
                      ""
                    )}
                  </div>
                  {modalData?.AuthorScreenName &&
                  modalData?.PlatformID !== 2 &&
                  modalData?.PlatformID !== 5 ? (
                    <div
                      className="screenName text-grayLight text-ellipsis w-100"
                      //style={{ width: "90%" }}
                    >
                      <Tooltip title={modalData?.AuthorScreenName}>
                        {modalData?.AuthorURL &&
                        modalData?.AuthorURL !== "NA" ? (
                          <a
                            className={
                              modalData?.AuthorURL &&
                              modalData?.AuthorURL !== "NA"
                                ? ""
                                : "pointer-events1 cursor-default"
                            }
                            href={
                              modalData?.AuthorURL &&
                              modalData?.AuthorURL !== "NA"
                                ? modalData?.AuthorURL
                                : ""
                            }
                            target="_blank"
                            rel="noreferrer"
                          >
                            {modalData?.AuthorScreenName}
                          </a>
                        ) : (
                          <>{modalData?.AuthorScreenName}</>
                        )}
                      </Tooltip>
                    </div>
                  ) : modalData?.ScreenName ? (
                    <div
                      className="screenName text-grayLight text-ellipsis w-100"
                      //style={{ width: "90%" }}
                    >
                      <Tooltip title={modalData?.ScreenName}>
                        {modalData?.AuthorURL &&
                        modalData?.AuthorURL !== "NA" ? (
                          <a
                            className={
                              modalData?.AuthorURL &&
                              modalData?.AuthorURL !== "NA"
                                ? ""
                                : "pointer-events1 cursor-default"
                            }
                            href={
                              modalData?.AuthorURL &&
                              modalData?.AuthorURL !== "NA"
                                ? modalData?.AuthorURL
                                : ""
                            }
                            target="_blank"
                            rel="noreferrer"
                          >
                            {modalData?.ScreenName}
                          </a>
                        ) : (
                          <>{modalData?.ScreenName}</>
                        )}
                      </Tooltip>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <span
                className="font-size12 align-items-center d-flex date-icons-header "
                style={{ maxWidth: "40%" }}
              >
                <Tooltip
                  title={
                    <div>
                      Created Date : <br />{" "}
                      {authParams?.screen_id &&
                      modalData?.CreatedDate &&
                      modalData?.CreatedDate_tooltip
                        ? modalData?.CreatedDate_tooltip
                        : modalData?.CreatedDate
                        ? modalData?.CreatedDate
                        : modalData?.PostCreatedDate}
                    </div>
                  }
                  className="no--wrap"
                >
                  {getDynamicIconColor("clock_icon")}
                  {/* <img
                    src={ClockIcon}
                    className="cardList__footer-label"
                    alt="ClockIcon"
                  /> */}
                  <span className="cardList__footer-count text-grayLight">
                    {/* {el?.CreatedDate} */}
                    {authParams?.screen_id && modalData?.CreatedDate
                      ? modalData?.CreatedDate
                      : moment(
                          modalData?.CreatedDate
                            ? modalData?.CreatedDate
                            : modalData?.PostCreatedDate
                        )?.format("DD MMM YYYY")}
                  </span>
                </Tooltip>
                {modalData?.IsDeletedFromSocial ? (
                  <Tooltip
                    title={<div>Deleted From Social</div>}
                    placement="topRight"
                    className="no--wrap"
                  >
                    <span
                      className={` deletedFromSocialIcon ${
                        qrChannel ? "d-none" : "d-flex align-items-center"
                      } `}
                    >
                      <i className="fas fa-trash-alt trash__icon"></i>
                    </span>
                  </Tooltip>
                ) : (
                  ""
                )}
              </span>
            </div>
            <div
              className="card-body p-0 custom_scroll1"
              style={{ maxHeight: "calc(100vh - 27.2rem)", overflow: "auto" }}
            >
              {modalData?.PlatformID === 1 ||
              modalData?.PlatformID === 7 ||
              modalData?.PlatformID === 30 ||
              isReviewCard ? (
                <div
                  className={`${PdfDownloadStatus ? "mb-5" : "mb-15"}  pl-15 ${
                    qrChannel ? "d-none" : "d-flex"
                  } justify-content-between pr-15 `}
                >
                  {modalData?.PlatformID === 1 && !qrChannel ? (
                    <span className="mr-15 d-flex align-items-center no--wrap">
                      <Tooltip
                        title={
                          modalData?.FollowersCount
                            ? modalData?.FollowersCount?.toLocaleString()
                            : modalData?.Followers?.toLocaleString()
                        }
                      >
                        <img
                          src={userFollowers}
                          className="cardList__footer-label mr-1"
                          alt="userFollowers"
                        />
                        <span className="text-grayLight ml-1">Followers</span>
                        <span className="cardList__footer-count ml-1 blue-text font-weight800">
                          {modalData?.FollowersCount
                            ? kFormatter(modalData?.FollowersCount)
                            : kFormatter(modalData?.Followers)}
                        </span>
                      </Tooltip>
                    </span>
                  ) : (
                    ""
                  )}
                  {/* Show For Only TikTok Channel */}
                  {modalData?.PlatformID === 37 &&
                  modalData?.SavedCount >= 0 &&
                  modalData?.SavedCount !== "NA" &&
                  modalData?.SavedCount !== null ? (
                    <Tooltip title="Saved Count">
                      <span className="mr-15 d-flex align-items-center no--wrap">
                        <img
                          src={
                            authParams?.theme_type === "1" ? white_Saved : saved
                          }
                          className="cardList__footer-label mr-1"
                          alt="saved"
                        />
                        <span className="text-grayLight ml-1">SavedCount</span>
                        <span className="cardList__footer-count ml-1 blue-text font-weight800">
                          {kFormatter(modalData?.SavedCount)}
                        </span>
                      </span>
                    </Tooltip>
                  ) : (
                    ""
                  )}
                  {/* Show For Only Instagram Channel */}
                  {modalData?.PlatformID === 3 &&
                  modalData?.SavedCount >= 0 &&
                  modalData?.SavedCount !== "NA" &&
                  modalData?.SavedCount !== null ? (
                    <Tooltip title="Post Saves">
                      <span className="mr-15 d-flex align-items-center no--wrap">
                        <img
                          src={
                            authParams?.theme_type === "1" ? white_Saved : saved
                          }
                          className="cardList__footer-label mr-1"
                          alt="saved"
                        />
                        <span className="text-grayLight ml-1">Post Saves</span>
                        <span className="cardList__footer-count ml-1 blue-text font-weight800">
                          {kFormatter(modalData?.SavedCount)}
                        </span>
                      </span>
                    </Tooltip>
                  ) : (
                    ""
                  )}

                  {isReviewCard ||
                  ((modalData?.PlatformID === 7 ||
                    modalData?.PlatformID === 30) &&
                    modalData?.IsBrandPost === "User") ? (
                    <>
                      {modalData?.Rating >= 0 ? (
                        <span className="mr-15 d-flex align-items-center">
                          <Rate
                            disabled
                            value={
                              modalData?.Rating
                                ? modalData?.Rating
                                : modalData?.rating
                            }
                            className="d-flex no--wrap w-100 ratingList mr-1 "
                          />
                          {modalData?.Rating}
                        </span>
                      ) : (
                        ""
                      )}

                      {modalData?.PlatformID === 7 ? (
                        <span className="mr-15 d-flex align-items-center">
                          <span
                            className="w-100 text-ellipsis mr-1"
                            style={{ color: "blue" }}
                          >
                            App Version:
                          </span>
                          {modalData?.App_version === "NA" ? (
                            <>
                              {"-"}
                              <Tooltip
                                title="Version information is not available for this review."
                                placement="top"
                                className="text-ellipsis d-inline-block wm-chart-card-title"
                              >
                                <i
                                  className={`fa fa-info-circle cursor-pointer ml-1 ${
                                    window.location.pathname
                                      .toLowerCase()
                                      ?.includes("/commandcenter/screens")
                                      ? "dynamic_icon_color"
                                      : "text-gray"
                                  }`}
                                  style={{ overflow: "visible" }}
                                />
                              </Tooltip>
                            </>
                          ) : (
                            modalData?.App_version
                          )}
                        </span>
                      ) : (
                        ""
                      )}
                      {modalData?.PlatformID === 7 ? (
                        <span className="mr-15 d-flex align-items-center">
                          <img
                            src={androidImage}
                            alt="Android Image"
                            className="profileImg ml-1 mr-1"
                            style={{ width: "1.5rem" }}
                          />
                          {modalData?.Android_version}
                        </span>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                ""
              )}

              {modalData?.PlatformID === 7 &&
              !qrChannel &&
              modalData?.IsBrandPost === "User" ? (
                <span className="ml-15 mb-5 d-flex align-items-center">
                  <span className="d-flex w-100">
                    <span
                      className="text-ellipsis mr-1"
                      style={{ color: "blue" }}
                    >
                      Device Name:
                    </span>
                    <span className="text-ellipsis">{modalData?.Device}</span>
                  </span>
                </span>
              ) : (
                ""
              )}
              {/* Additional for E-Commerce channel */}
              {modalData?.PlatformID === 14 ? (
                <span className="ml-15 mb-10 d-flex align-items-center">
                  <span
                    className={`w-100 ${
                      getTextDirection(modalData?.Title || "") === "rtl"
                        ? "d-flex justify-content-between"
                        : ""
                    }`}
                  >
                    <span
                      className={
                        authParams?.screen_id && !isDeepDiveDashboardView
                          ? "color-white"
                          : ""
                      }
                      style={{
                        flexShrink:
                          getTextDirection(modalData?.Title || "") === "rtl"
                            ? 0
                            : 1,
                      }}
                    >
                      Title :
                    </span>
                    <span
                      className={`${
                        authParams?.screen_id && !isDeepDiveDashboardView
                          ? "color-white font-weight800"
                          : "font-weight800"
                      } ${
                        getTextDirection(modalData?.Title || "") === "rtl"
                          ? "text-right-arabic mr-15"
                          : ""
                      }`}
                    >
                      {" "}
                      {getTextWithWrapHtml(
                        modalData?.Title !== "" &&
                          modalData?.Title !== "NA" &&
                          modalData?.Title
                          ? modalData?.Title
                          : "NA",
                        "",
                        highlightWord
                      )}
                    </span>
                  </span>
                </span>
              ) : (
                ""
              )}
              {modalData?.PlatformID === 14 ? (
                <span className="ml-15 mb-10 d-flex align-items-center">
                  <span
                    className={`w-100 ${
                      getTextDirection(modalData?.ProductName || "") === "rtl"
                        ? "d-flex justify-content-between"
                        : ""
                    }`}
                  >
                    <span
                      className={
                        authParams?.screen_id && !isDeepDiveDashboardView
                          ? "color-white"
                          : ""
                      }
                      style={{
                        flexShrink:
                          getTextDirection(modalData?.ProductName || "") ===
                          "rtl"
                            ? 0
                            : 1,
                      }}
                    >
                      Product Name :
                    </span>
                    <span
                      className={`${
                        authParams?.screen_id && !isDeepDiveDashboardView
                          ? "color-white font-weight800"
                          : "font-weight800"
                      } ${
                        getTextDirection(modalData?.ProductName || "") === "rtl"
                          ? "text-right-arabic mr-15"
                          : ""
                      }`}
                    >
                      {" "}
                      {getTextWithWrapHtml(
                        modalData?.ProductName !== "" &&
                          modalData?.ProductName !== "NA" &&
                          modalData?.ProductName
                          ? modalData?.ProductName
                          : "NA",
                        "",
                        highlightWord
                      )}
                    </span>
                  </span>
                </span>
              ) : (
                ""
              )}

              {qrChannel ? (
                <div className="m-0 w-100 d-flex flex-wrap pl-15 pr-15 pb-15">
                  {Array.isArray(el?.SurveySubmitJson) &&
                    el?.SurveySubmitJson?.map((d, i) => {
                      return (
                        <>
                          {d?.ratingType &&
                          ["star", "emoji", "nps"]?.includes(d?.ratingType) ? (
                            <div className="w-100">
                              <div className="mb-1 text_heading fontSize-12 font-weight600 surevyCard--title">
                                {getTextWithWrapHtml(
                                  d?.labelname,
                                  "",
                                  highlightWord
                                )}
                              </div>
                              <div className="d-flex align-items-center justify-content-center w-100 mb-1">
                                {d?.ratingType &&
                                ["star", "emoji", "nps"]?.includes(
                                  d?.ratingType
                                ) ? (
                                  <>
                                    <div className="rating-builder">
                                      {d?.ratingType === "star" ? (
                                        <Rate
                                          disabled
                                          value={d?.value}
                                          className="no--wrap w-100 ratingList mr-1"
                                          style={{
                                            fontSize: "3.2rem",
                                          }}
                                        />
                                      ) : d?.ratingType === "emoji" ? (
                                        <div className="rating-builder__wrapper">
                                          <img
                                            src={smilingFaceWithHeartEyes}
                                            alt=""
                                            className={`${
                                              parseInt(d?.value) === 5
                                                ? "emoji-selected emoji-hover"
                                                : "filter-grey"
                                            }`}
                                            style={{
                                              width:
                                                parseInt(d?.value) === 5
                                                  ? "4rem"
                                                  : "3.2rem",
                                              minWidth:
                                                parseInt(d?.value) === 5
                                                  ? "4rem"
                                                  : "3.2rem",
                                              maxWidth:
                                                parseInt(d?.value) === 5
                                                  ? "4rem"
                                                  : "3.2rem",
                                            }}
                                          />
                                          <img
                                            src={smilingFaceWithSmilingEyes}
                                            alt=""
                                            className={`${
                                              parseInt(d?.value) === 4
                                                ? "emoji-selected emoji-hover"
                                                : "filter-grey"
                                            }`}
                                            style={{
                                              width:
                                                parseInt(d?.value) === 4
                                                  ? "4rem"
                                                  : "3.2rem",
                                              minWidth:
                                                parseInt(d?.value) === 4
                                                  ? "4rem"
                                                  : "3.2rem",
                                              maxWidth:
                                                parseInt(d?.value) === 4
                                                  ? "4rem"
                                                  : "3.2rem",
                                            }}
                                          />
                                          <img
                                            src={neutralFace}
                                            alt=""
                                            className={`${
                                              parseInt(d?.value) === 3
                                                ? "emoji-selected emoji-hover"
                                                : "filter-grey"
                                            }`}
                                            style={{
                                              width:
                                                parseInt(d?.value) === 3
                                                  ? "4rem"
                                                  : "3.2rem",
                                              minWidth:
                                                parseInt(d?.value) === 3
                                                  ? "4rem"
                                                  : "3.2rem",
                                              maxWidth:
                                                parseInt(d?.value) === 3
                                                  ? "4rem"
                                                  : "3.2rem",
                                            }}
                                          />
                                          <img
                                            src={frowningFace}
                                            alt=""
                                            className={`${
                                              parseInt(d?.value) === 2
                                                ? "emoji-selected emoji-hover"
                                                : "filter-grey"
                                            }`}
                                            style={{
                                              width:
                                                parseInt(d?.value) === 2
                                                  ? "4rem"
                                                  : "3.2rem",
                                              minWidth:
                                                parseInt(d?.value) === 2
                                                  ? "4rem"
                                                  : "3.2rem",
                                              maxWidth:
                                                parseInt(d?.value) === 2
                                                  ? "4rem"
                                                  : "3.2rem",
                                            }}
                                          />

                                          <img
                                            src={tiredEmoji}
                                            alt=""
                                            className={`${
                                              parseInt(d?.value) === 1
                                                ? "emoji-selected emoji-hover"
                                                : "filter-grey"
                                            }`}
                                            style={{
                                              width:
                                                parseInt(d?.value) === 1
                                                  ? "4rem"
                                                  : "3.2rem",
                                              minWidth:
                                                parseInt(d?.value) === 1
                                                  ? "4rem"
                                                  : "3.2rem",
                                              maxWidth:
                                                parseInt(d?.value) === 1
                                                  ? "4rem"
                                                  : "3.2rem",
                                            }}
                                          />
                                        </div>
                                      ) : d?.ratingType === "nps" ? (
                                        <div className="rating-builder__wrapper">
                                          <ul className="rating-builder__nps cursor-pointer p-0 mb-1">
                                            {Array.isArray(NPS_OPTIONS) &&
                                              NPS_OPTIONS?.map((n) => {
                                                return (
                                                  <li
                                                    className={`list ${
                                                      n > 7
                                                        ? "bg__green"
                                                        : n == 6 || n == 7
                                                        ? "bg__yellow--dark"
                                                        : n < 6
                                                        ? "bg__red--dark"
                                                        : ""
                                                    } ${
                                                      parseInt(d?.value) === n
                                                        ? "select-nps"
                                                        : "unselect-nps"
                                                    }`}
                                                  >
                                                    {n}
                                                  </li>
                                                );
                                              })}
                                          </ul>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </>
                                ) : (
                                  <span class="pre--wrap text-grayLight surevyCard--value">
                                    {getTextWithWrapHtml(
                                      d?.value,
                                      "",
                                      highlightWord
                                    )}
                                  </span>
                                )}
                              </div>
                            </div>
                          ) : (
                            <div
                              className={`d-flex align-items-center mb-1 ${
                                Number(d?.fieldType) ===
                                ElementTypeEnum?.textarea
                                  ? "w-100"
                                  : ""
                              }`}
                            >
                              {/* <span className="mr-3 text_heading fontSize-12 font-weight600 surevyCard--title">
                                {d?.labelname}
                              </span>
                              <span className="d-flex align-items-center">
                                <span class="pre--wrap text-grayLight surevyCard--value">
                                  {d?.value}
                                </span>
                              </span> */}
                              <span className="mr-2 pre--wrap text-grayLight surevyCard--value ">
                                <span className="mr-1 text_heading fontSize-12 font-weight600 surevyCard--title">
                                  {getTextWithWrapHtml(
                                    d?.labelname,
                                    "",
                                    highlightWord
                                  )}
                                </span>{" "}
                                {getTextWithWrapHtml(
                                  d?.value,
                                  "",
                                  highlightWord
                                )}
                              </span>
                            </div>
                          )}
                        </>
                      );
                    })}
                </div>
              ) : (
                ""
              )}
              <div
                className={`cardList__body-description  fontSize-12 pl-15 pr-15`}
              >
                {!qrChannel &&
                (modalData?.PostText || modalData?.mention_text) ? (
                  <div
                    className={`text_regular break-word mb-15 ${textDirectionClass}`}
                  >
                    {!(
                      isModalReadMore?.value &&
                      isModalReadMore?.id === modalData?.TagID
                    ) && (
                      <>
                        <a
                          className={
                            modalData?.PostURL &&
                            modalData?.PostURL?.trim() &&
                            modalData?.PostURL !== "NA" &&
                            authParams?.screen_id !== "000-000-563" &&
                            !isReviewCard
                              ? ""
                              : "pointer-events1 cursor-default"
                          }
                          href={
                            modalData?.PostURL &&
                            modalData?.PostURL?.trim() &&
                            modalData?.PostURL !== "NA" &&
                            !isReviewCard
                              ? modalData?.PostURL
                              : ""
                          }
                          target="_blank"
                          rel="noreferrer"
                        >
                          {el?.IsMaskedMention &&
                          idPresentFlag &&
                          !isPreviewState &&
                          !isDashboardScheduleModal &&
                          !PdfDownloadStatus &&
                          !PptGeneratingStatus &&
                          (window.location.pathname?.split("/")?.[1] ===
                            "widgetMaker" ||
                            window.location.pathname?.split("/")?.[1] ===
                              "edit-widget" ||
                            window.location.pathname?.split("/")?.[1] ===
                              "dashboard" ||
                            window.location.pathname?.split("/")?.[1] ===
                              "pin-dashboard" ||
                            authParams?.screen_id)
                            ? finalPostText !== ""
                              ? getTextWithWrapHtml(
                                  finalPostText,
                                  "",
                                  highlightWord,
                                  textDirection,
                                  needToShowScrollableContent
                                )
                              : getTextWithWrapHtml(
                                  modalData?.PostText ||
                                    modalData?.mention_text,
                                  "",
                                  highlightWord,
                                  textDirection,
                                  needToShowScrollableContent
                                )
                            : getTextWithWrapHtml(
                                modalData?.PostText || modalData?.mention_text,
                                "",
                                highlightWord,
                                textDirection,
                                needToShowScrollableContent
                              )}
                        </a>
                      </>
                    )}
                  </div>
                ) : (
                  ""
                )}

                {modalData?.Attachment?.length === 1 ? (
                  <div className="m-0 w-100 text-center position-relative postCard_dtails--image">
                    {modalData?.Attachment?.map((imgUrl, index) => {
                      if (
                        imgUrl?.MediaType === "2" ||
                        imgUrl?.MediaType === "4"
                      ) {
                        return imgUrl ? (
                          <>
                            <Image
                              src={
                                imgUrl?.ThumbUrl ? imgUrl?.ThumbUrl : defaultImg
                              }
                              alt="Attachment Image"
                              style={{
                                borderRadius: "0.6rem",
                                objectFit: "cover",
                                minHeight: "35rem",
                              }}
                              onError={onImageError}
                              className="border w-100"
                              fallback={defaultImg}
                              preview={!isImage}
                              placeholder={
                                <Image
                                  src={placeHolderImg}
                                  preview={false}
                                  className="position_relative w-100"
                                  style={{
                                    borderRadius: "3.2rem",
                                    objectFit: "cover",
                                    height: "35rem",
                                  }}
                                />
                              }
                            />
                          </>
                        ) : (
                          ""
                        );
                      } else if (
                        imgUrl?.MediaType === "3" ||
                        imgUrl?.MediaType === "7"
                      ) {
                        return imgUrl && !PdfDownloadStatus ? (
                          <>
                            {modalData?.PlatformID === 2 ||
                            modalData?.PlatformID === 4 ||
                            modalData?.PlatformID === 37 ? (
                              <a
                                href={imgUrl?.MediaUrl ? imgUrl?.MediaUrl : ""}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <img
                                  src={
                                    imgUrl?.ThumbUrl
                                      ? imgUrl?.ThumbUrl
                                      : defaultImg
                                  }
                                  alt="Attachment Images"
                                  style={{ width: "100%", objectFit: "cover" }}
                                  onError={(modalData) =>
                                    onImageError(modalData)
                                  }
                                />
                                <div class="overlay-play-button__overlay">
                                  <div class="overlay-play-button__play">
                                    <i
                                      class="fa fa-play"
                                      style={{
                                        fontSize: "1.2rem",
                                        color: "#fff",
                                      }}
                                    ></i>
                                  </div>
                                </div>
                              </a>
                            ) : modalData?.PlatformID === 1 ||
                              modalData?.PlatformID === 3 ||
                              modalData?.PlatformID === 5 ||
                              modalData?.PlatformID === 37 ||
                              modalData?.PlatformID === 42 ? (
                              <>
                                <div
                                  class="overlay-play-button"
                                  style={{ height: "25rem" }}
                                  onClick={() => handleVideoPreview(imgUrl)}
                                >
                                  <video
                                    width="100%"
                                    style={{
                                      objectFit: "cover",
                                      height: "25rem",
                                    }}
                                  >
                                    <source
                                      src={
                                        imgUrl?.MediaUrl
                                          ? imgUrl?.MediaUrl
                                          : defaultImg
                                      }
                                      type="video/mp4"
                                    />
                                  </video>

                                  <div class="overlay-play-button__overlay">
                                    <div class="overlay-play-button__play">
                                      <i
                                        class="fa fa-play"
                                        style={{
                                          fontSize: "1.2rem",
                                          color: "#fff",
                                        }}
                                      ></i>
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : (
                              ""
                            )}

                            {/* For Video Preview */}
                            <VideoPreview
                              videoPreview={videoPreview}
                              setIsModalOpen={setIsVideoModalOpen}
                              isModalOpen={isVideoModalOpen}
                              isValidUrlFlag={isValidUrlFlag}
                              isDeepDiveDashboardView={isDeepDiveDashboardView}
                            />
                          </>
                        ) : PdfDownloadStatus ? (
                          imgUrl && (
                            <img
                              src={imgUrl?.ThumbUrl}
                              alt="Attachment Images"
                              style={{
                                width: "8rem",
                                height: "6.6rem",
                              }}
                              onError={(modalData) => onImageError(modalData)}
                            />
                          )
                        ) : (
                          ""
                        );
                      } else if (imgUrl?.MediaType === "8") {
                        return (
                          <div
                            className="post__document"
                            style={{
                              width: "100%",
                              height: "30rem",
                            }}
                          >
                            <span className="post__document--files">
                              <a
                                href={imgUrl?.MediaUrl ? imgUrl?.MediaUrl : ""}
                                download={imgUrl?.Name}
                                target="_blank"
                                rel="noreferrer"
                                onClick={(e) => e?.stopPropagation()}
                              >
                                <img
                                  src={pdfIcon}
                                  alt="PDF Document"
                                  style={{
                                    width: "75%",
                                    height: "calc(100% - 5rem)",
                                    objectFit: "contain",
                                  }}
                                />
                                <Tooltip
                                  title={imgUrl?.Name}
                                  placement="bottom"
                                >
                                  <span className="post__document--name text__ellipsis-line2">
                                    {imgUrl?.Name}
                                  </span>
                                </Tooltip>
                              </a>
                            </span>
                          </div>
                        );
                      }
                    })}
                  </div>
                ) : (
                  modalData?.Attachment?.length > 1 && (
                    <div className="w-100">
                      <CarouselWidgetMaker
                        el={modalData}
                        height="40.3rem"
                        postCardDetails={true}
                        isDeepDiveDashboardView={isDeepDiveDashboardView}
                      />
                    </div>
                  )
                )}
              </div>
              {modalData?.post_label &&
              Array.isArray(modalData?.post_label) &&
              modalData?.post_label?.length > 0 ? (
                <div className="ner-attribute p-15 pb-0 m-0">
                  <div className="text_regular font-weight500">
                    {modalData?.post_label?.length > 1 ? "Labels:" : "Label:"}
                  </div>
                  <PostLabels pills={modalData?.post_label} />
                </div>
              ) : (
                ""
              )}
              <PostCardFooter
                data={data}
                isPreviewState={isPreviewState}
                PdfDownloadStatus={PdfDownloadStatus}
                PptGeneratingStatus={PptGeneratingStatus}
                el={modalData}
                postDetail={true}
                isReviewCard={isReviewCard}
                qrChannel={qrChannel}
                pantipChannel={pantipChannel}
                section_index={section_index}
                widget_index={widget_index}
                highlightWord={highlightWord}
                isDeepDiveDashboardView={isDeepDiveDashboardView}
              />
            </div>
            {!isReviewCard &&
            modalData?.PlatformID !== 7 &&
            modalData?.PlatformID !== 30 &&
            !pantipChannel &&
            !qrChannel ? (
              <div className="card-footer text-center bg__white text_regular d-flex align-items-top pt-2 pb-2 pl-15 pr-15 border-top border-color">
                <div
                  className="mr-15 brandPosts__footerWrap"
                  style={{ width: "25%" }}
                >
                  <div className="text_regular text-grayLight white-space-nowrap">
                    Engagement
                  </div>
                  <div className="text_heading-Rubik font-size18 line-height-normal">
                    <div>
                      <Tooltip title={modalData?.Engagement?.toLocaleString()}>
                        {" "}
                        {kFormatter(modalData?.Engagement)}{" "}
                      </Tooltip>{" "}
                    </div>
                    {modalData?.PlatformID === 3 &&
                    modalData?.isPromoted === 5 ? (
                      <Tooltip
                        title={
                          "This Post Has No AD ID, So Engagement Only Includes Basic Stats Like Likes And Comments."
                        }
                      >
                        <img
                          src={InfoIconYellow}
                          style={{ maxWidth: "1.5rem" }}
                          className="mr-1 cursor-pointer"
                          alt="info"
                        />
                      </Tooltip>
                    ) : modalData?.engagement_fx ? (
                      <Tooltip title={modalData?.Engagement_text}>
                        <img
                          src={fx}
                          style={{ maxWidth: "1.5rem" }}
                          className="mr-1 cursor-pointer"
                          alt="fx"
                        />
                      </Tooltip>
                    ) : (
                      ""
                    )}
                  </div>
                  {/* <Progress
                percent={el?.Engagement}
                showInfo={false}
                trailColor={"#c0c2c5"}
              /> */}
                </div>
                <div className="mr-15" style={{ width: "25%" }}>
                  <div className="text_regular text-grayLight white-space-nowrap cursor-pointer">
                    <Tooltip title="Engagement Rate">
                      <div className="white-space-nowrap">Eng. Rate</div>
                    </Tooltip>
                  </div>
                  <div className="text_heading-Rubik font-size18 line-height-normal">
                    <div>
                      <Tooltip
                        title={modalData?.Engagement_rate?.toLocaleString()}
                      >
                        {" "}
                        {kFormatter(modalData?.Engagement_rate)}
                      </Tooltip>{" "}
                    </div>
                    {modalData?.Engagement_rate_fx ? (
                      <Tooltip title={modalData?.Engagement_rate_text}>
                        <img
                          src={fx}
                          style={{ maxWidth: "1.5rem" }}
                          className="mr-1 cursor-pointer"
                          alt="fx"
                        />
                      </Tooltip>
                    ) : (
                      ""
                    )}
                  </div>
                  {/* <Progress
                    percent={el?.Engagement}
                    showInfo={false}
                    trailColor={"#c0c2c5"}
                  /> */}
                </div>
                <div className="mr-15" style={{ width: "25%" }}>
                  <div
                    className={`text_regular text-grayLight d-inline-flex align-items-center ${
                      modalData?.reach_fx ? "cursor-pointer" : ""
                    }`}
                  >
                    {modalData?.reach_fx ? (
                      <Tooltip title="Estimated Reach">
                        <div className="white-space-nowrap">Est. Reach</div>
                      </Tooltip>
                    ) : (
                      <div className="white-space-nowrap">Reach</div>
                    )}
                    {modalData?.reach_i && (
                      <Tooltip title="It looks like this video post has been watched by the same viewers multiple times.">
                        <img src={InfoIcon} alt="InfoIcon" className="ml-1" />
                      </Tooltip>
                    )}
                  </div>
                  <div className="text_heading-Rubik font-size18 line-height-normal">
                    <div>
                      {" "}
                      <Tooltip title={modalData?.Reach?.toLocaleString()}>
                        {" "}
                        {kFormatter(modalData?.Reach)}
                      </Tooltip>{" "}
                    </div>
                    {modalData?.reach_fx && (
                      <Tooltip title={modalData?.Reach_text}>
                        <img
                          src={fx}
                          style={{ maxWidth: "1.5rem" }}
                          className="mr-1 cursor-pointer"
                          alt="fx"
                        />
                      </Tooltip>
                    )}
                  </div>
                  {/* <Progress
                percent={el?.Reach}
                showInfo={false}
                trailColor={"#c0c2c5"}
              /> */}
                </div>
                <div style={{ width: "25%" }}>
                  {modalData?.impression_fx ? (
                    <Tooltip title="Estimated Impression">
                      <div className="text_regular text-grayLight white-space-nowrap cursor-pointer">
                        {" "}
                        Est. Impression
                      </div>
                    </Tooltip>
                  ) : (
                    <div className="text_regular text-grayLight white-space-nowrap">
                      Impression
                    </div>
                  )}
                  <div className="text_heading-Rubik font-size18 line-height-normal">
                    <div>
                      {" "}
                      <Tooltip title={modalData?.Impression?.toLocaleString()}>
                        {" "}
                        {kFormatter(modalData?.Impression, false, true)}
                      </Tooltip>{" "}
                    </div>
                    {modalData?.impression_fx && (
                      <Tooltip title={modalData?.Impression_text}>
                        <img
                          src={fx}
                          style={{ maxWidth: "1.5rem" }}
                          className="mr-1 cursor-pointer"
                          alt="fx"
                        />
                      </Tooltip>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        )
      ) : (
        <div
          className="portlet_images text-center pt-4 mt-15 col-12"
          style={{ minHeight: "45rem" }}
        >
          <img
            alt="no data"
            src={somethingWentWrong}
            style={{ maxWidth: "100%", minWidth: "20rem" }}
          />
          <p className="mt-15 text_regular-gray">No Data Found</p>
        </div>
      )}
    </Modal>
  );
};

export default React.memo(PostCardDetails, isEqual);
